import { defineMessages } from "react-intl";

export const scope = "pages.SingleMemberPage";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Usuarios",
  },
  totalBalance: {
    id: `${scope}.totalBalance`,
    defaultMessage: "Total en cartera",
  },
  platformPill: {
    id: `${scope}.platformPill`,
    defaultMessage: "Plataforma",
  },
  localMarketPill: {
    id: `${scope}.localMarketPill`,
    defaultMessage: "Mercado local",
  },
  globalMarketPill: {
    id: `${scope}.globalMarketPill`,
    defaultMessage: "Mercado global",
  },
  lastMovements: {
    id: `${scope}.lastMovements`,
    defaultMessage: "Últimos movimientos",
  },
});
